import type {Components, Theme} from '@mui/material/styles';

export const tooltipOverrides: Components<Theme>['MuiTooltip'] = {
    styleOverrides: {
        tooltip: {
            borderRadius: '4px',
        },
    },
};
